import { WriteRequest } from '@aws-sdk/client-dynamodb'
import { BatchGetCommandInput, BatchWriteCommandInput } from '@aws-sdk/lib-dynamodb'
import config from '@iotv/config'
import { DatastoreObjectTypes } from '@iotv/iotv-v3-types'

const dyn = config.aws.dynamoDB

export enum DynamoDBBatchAction {
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export type GetBatchOperationsParamsRequest = {
  items: DatastoreObjectTypes
  action: DynamoDBBatchAction
  /** table name override, default is main table */
  tableNameOverride?: string
}

export const getBatchPutDeleteOperationParams = ({ items, action, tableNameOverride }: GetBatchOperationsParamsRequest): BatchWriteCommandInput => {
  const resolvedTableName: string = tableNameOverride ?? dyn.tableName
  items = items.reduce((a, c) => {
    if (!a.find((b) => b.sk === c.sk && b.pk === c.pk)) {
      a.push(c)
    }
    return a
  }, [] as DatastoreObjectTypes)
  const params: BatchWriteCommandInput = {
    RequestItems: {
      [resolvedTableName]: items.map((item) => {
        const request: WriteRequest = {
          [action === DynamoDBBatchAction.PUT ? 'PutRequest' : 'DeleteRequest']:
            action === DynamoDBBatchAction.PUT
              ? {
                  Item: item,
                }
              : { Key: { sk: item.sk, pk: item.pk } },
        }
        return request
      }),
    },
  }
  return params
}
